import { ALL_REVIEWS } from "../../data/reviews";

export function filterReviewsByService(serviceNav, limit = 3) {
    return ALL_REVIEWS.filter((r) => r.service === serviceNav).slice(0, limit);
}

export function filterReviewsByBrand(brandName, limit = 3) {
    return ALL_REVIEWS.filter((r) => r.brand === brandName).slice(0, limit);
}

export function reviewsJsonLd(reviews) {
    return reviews.map((r) => ({
        "@type": "Review",
        "author": { "@type": "Person", "name": r.name },
        "datePublished": r.date,
        "reviewBody": r.text,
        "reviewRating": { "@type": "Rating", "ratingValue": String(r.rating), "bestRating": "5" },
    }));
}

export default function ReviewsStrip({ reviews, title }) {
    if (!reviews || reviews.length === 0) return null;
    const gridCols = reviews.length >= 3 ? "md:grid-cols-3" : reviews.length === 2 ? "md:grid-cols-2 max-w-4xl" : "max-w-xl";
    return (
        <section className="bg-[var(--paper)] border-y border-[var(--line)]" data-testid="reviews-strip">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14">
                <div className="divider-amber mb-5" />
                <h2 className="heading text-2xl lg:text-3xl font-extrabold">{title}</h2>
                <div className={`mt-8 grid gap-5 ${gridCols}`}>
                    {reviews.map((r) => (
                        <article key={`${r.name}-${r.date}`} className="card-soft p-5 bg-white" data-testid={`review-card-${r.name.replace(/[^a-zA-Z]/g, "")}`}>
                            <div className="flex items-center gap-1 text-[var(--amber)]" aria-label={`${r.rating} étoiles sur 5`}>
                                {Array.from({ length: r.rating }).map((_, i) => (
                                    <i key={`s-${i}`} className="fa-solid fa-star text-sm" />
                                ))}
                            </div>
                            <p className="mt-3 text-sm text-[var(--ink-soft)] leading-relaxed">{r.text}</p>
                            <p className="mt-4 text-xs font-semibold text-[var(--navy)]">
                                {r.name} · {r.city}
                                <span className="font-normal text-[var(--ink-soft)]"> · {r.service}</span>
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
